// @ts-ignore
// @ts-nocheck
// tslint:disable: object-literal-shorthand
// tslint:disable: prefer-const
// tslint:disable: space-before-function-paren
// tslint:disable: curly
// tslint:disable: no-var-keyword
// tslint:disable: only-arrow-functions
// tslint:disable: variable-name
// tslint:disable: jsdoc-format
// tslint:disable: forin
// tslint:disable: no-bitwise
// tslint:disable: no-eval
// tslint:disable: quotemark
// tslint:disable: no-unused-expression
// tslint:disable: radix
// tslint:disable: no-conditional-assignment
//
// vim:ts=4:sw=4:expandtab
//
// Copyright (c) 2012-2021 Echo Software, Ltd.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//
//

import './string-lib';

// TODO: make some types due to project refactoring
const RZLib: any = {
  Version: '0.1',

  subclass(superClass, className, methods) {
    var newClass =
      methods[className] || eval("({ '" + className + "': function() { superClass.call() } })['" + className + "']");

    if (superClass) {
      var f = function () {};
      f.prototype = superClass.prototype;

      newClass.prototype = new f();
      newClass.prototype.constructor = newClass;
      newClass.superClass = superClass.prototype;
      newClass.superConstructor = superClass;

      Object.setPrototypeOf(newClass, superClass);
    }

    for (let mName in methods) {
      newClass.prototype[mName] = methods[mName];
    }

    return newClass;
  },
};

RZLib.Object = { 'RZLib.Object': function () {} }['RZLib.Object'];

RZLib.Object.prototype = {
  isa: function (other) {
    return this.constructor;
  },
  isMemberOf: function (other) {
    return this.isa() === other;
  },
  isKindOf: function (other) {
    for (let thisClass = this.isa(); thisClass; thisClass = thisClass.superConstructor)
      if (thisClass === other) return true;

    return false;
  },
  clone: function () {
    var copy = new (this.isa())();
    for (prop in this) {
      if (this.hasOwnProperty(prop)) copy[prop] = this[prop];
    }
    return copy;
  },
};

RZLib.isKindOf = function (obj, cls) {
  if (typeof obj == 'object' && obj != null && typeof obj.isKindOf == 'function' && typeof obj.isa == 'function')
    return obj.isKindOf(cls);

  return false;
};

RZLib.parseDate = function (str) {
  if (typeof str != 'string') return null;

  var m = str.match(/^\s*(today|now)/i, '');
  if (m) {
    let t = RZLib.Date.newWithToday();
    return [m[1], t.year, t.month, t.day];
  }

  var m = str.match(/^\s*(yesterday)/i, '');
  if (m) {
    let t = RZLib.Date.newWithToday().addYMD(0, 0, -1);
    return [m[1], t.year, t.month, t.day];
  }

  // first try yyyy/mm/dd
  var m = str.match(/\s*((\d\d\d\d)[\/.-](\d{1,2})[\/.-](\d{1,2}))/, '');
  if (m) {
    return [m[1], m[2], m[3], m[4], str.substr(m[0].length)];
  }

  // then try mm/dd/yyyy
  var m = str.match(/\s*((\d{1,2})[\/.-](\d{1,2})[\/.-](\d\d\d\d))/, '');
  if (m) {
    return [m[1], m[4], m[2], m[3]];
  }

  return null;
};

RZLib.parseTime = function (str) {
  if (typeof str != 'string') return null;

  var m = str.match(/\s*((\d\d?):(\d\d)(?::(\d\d)(?:\.\d+)?)?\s*(am|pm|)?)/i);
  if (m) {
    return [m[1], m[2], m[3], m[4] || 0, m[5] || '', str.substr(m[0].length)];
  }

  return null;
};

RZLib.parseTimestamp = function (str) {
  var md = RZLib.parseDate(str);
  if (!md) return null;

  var mt = str.substr(md[0].length).match(/\s*((\d\d?):(\d\d):(\d\d)(?:\.\d+)?\s*([+-]\d{2,4})?)/i);
  if (mt) {
    return [md[0] + ' ' + mt[1], md[1], md[2], md[3], mt[2], mt[3], mt[4], (mt[5] + '000000').substr(0, 6), mt[6]];
  }

  return null;
};

RZLib.eqv = function (a, b) {
  var ta = typeof a;
  var tb = typeof b;

  if (ta != tb) return false;

  var ua = a == undefined;
  var ub = b == undefined;

  if (ua && ub) return true;

  if (ua ^ ub) return false;

  if (Array.isArray(a) || Array.isArray(b)) return RZLib.array_eqv(a, b);

  // TODO: research from where it is get? from window obj??
  if (RZLib.isKindOf(a, DBLib) && RZLib.isKindOf(b, DBLib)) return a._id == b._id;

  if (ta == 'object' && tb == 'object') return RZLib.hash_eqv(a, b);

  return a == b;
};

RZLib.array_eqv = function (a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) return false;

  if (a.length != b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (!RZLib.eqv(a[i], b[i])) return false;
  }

  return true;
};

RZLib.hash_eqv = function (a, b) {
  if (Object.keys(a).length != Object.keys(b).length) return false;

  for (let k in a) {
    if (!RZLib.eqv(a[k], b[k])) return false;
  }

  return true;
};

RZLib.polymod = function (n) {
  var r = [];

  for (let i = 1; i < arguments.length; ++i) {
    var d = arguments[i];
    var m = n % d;
    r.push(m);
    n = (n - m) / d;
  }

  r.push(n);
  return r;
};

RZLib.decToFrac = function (d) {
  var dInt = Math.trunc(d);
  var dEighths = Math.round((d - dInt) * 8);
  dEighths = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'][dEighths];

  if (dInt == 0) dInt = '';

  var s = dInt + dEighths;
  if (s.length == 0) s = '0';

  return s;
};

RZLib.flattenHash = function flattenHash(attrHash, stripNull, prefix, flatHash) {
  if (!prefix) prefix = '';
  if (!flatHash) flatHash = {};

  for (let k in attrHash) {
    let fk = prefix ? `${prefix}.${k}` : k;
    let v = attrHash[k];

    if (v != null && v.toString() === '[object Object]') {
      RZLib.flattenHash(v, stripNull, fk, flatHash);
    } else if (v == null && stripNull) {
      // don't copy null value
    } else {
      flatHash[fk] = attrHash[k];
    }
  }

  return flatHash;
};

RZLib.expandHash = function expandHash(attrHash, stripNull, rootHash) {
  if (!rootHash) rootHash = {};

  for (let ahk in attrHash) {
    let keyPath = ahk.split(/\./);
    let k = keyPath.pop();

    let pathHash = rootHash;
    for (let k of keyPath) {
      if (pathHash[k] == undefined) pathHash[k] = {};
      pathHash = pathHash[k];
    }
    if (attrHash[ahk] == null && stripNull) {
      // don't copy null value
    } else {
      pathHash[k] = attrHash[ahk];
    }
  }

  return rootHash;
};

RZLib.hoursToDays = function htd(hours, hoursPerDay) {
  if (isNaN(hours)) return '';

  var h = hours % hoursPerDay;
  var d = (hours - h) / hoursPerDay;

  if (d == 0 && h == 0) return '0d';
  else if (h == 0) return d + 'd';
  else if (d == 0) return RZLib.decToFrac(h) + 'h';

  return `${d}d ${RZLib.decToFrac(h)}h`;
};

RZLib.interval = function (t, p) {
  if (t == undefined) return p;

  if (t < 60) return '%dsec'.sprintf(t);

  t /= 60;
  if (t < 60) return '%.1fmin'.sprintf(t);

  t /= 60;
  if (t < 24) return '%.1fhr'.sprintf(t);

  t /= 24;
  return '%.1fdy'.sprintf(t);
};

RZLib.nth = function (n) {
  if (n > 10 && n < 20) return n + 'th';

  switch (n % 10) {
    case 1:
      return n + 'st';
    case 2:
      return n + 'nd';
    case 3:
      return n + 'rd';
  }

  return n + 'th';
};

RZLib._tzString = function (dt) {
  var mm = (dt.tzOffset / 60000000) % 60;
  var hh = (dt.tzOffset / 3600000000) % 24;

  return '%s%02d%02d'.sprintf(hh < 0 ? '-' : '+', Math.abs(hh), mm).replace(/0+$/, '');
};

RZLib.strftime = function (fmt, dt) {
  var str = fmt.replace(/%((?:\+)?[aAbBCdDeFgHIjklmMnpPsSTuUwyYz\/$%])/g, function ($0, $1) {
    switch ($1) {
      case 'a':
        return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dt.dayOfWeek()];
      case 'A':
        return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dt.dayOfWeek()];
      case 'b':
        return ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][dt.month];
      case 'B':
        return [
          '',
          'January',
          'Febuary',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ][dt.month];
      case 'C':
        return '%02d'.sprintf(Math.floor(dt.year / 100));
      case 'd':
        return '%02d'.sprintf(dt.day);
      case '+d':
        return RZLib.nth(dt.day);
      case 'D':
        return '%02d/%02d/%04d'.sprintf(dt.month, dt.day, dt.year);
      case 'e':
        return '%2d'.sprintf(dt.day);
      case 'F':
        return '%04d-%02d-%02d'.sprintf(dt.year, dt.month, dt.day);
      case 'H':
        return '%02d'.sprintf(dt.hour);
      case 'I':
        return '%02d'.sprintf(((dt.hour + 11) % 12) + 1);
      case 'j':
        return '%03d'.sprintf(dt.dayOfYear());
      case 'k':
        return '%2d'.sprintf(dt.hour);
      case 'l':
        return '%2d'.sprintf(((dt.hour + 11) % 12) + 1);
      case 'm':
        return '%02d'.sprintf(dt.month);
      case 'M':
        return '%02d'.sprintf(dt.minute);
      case 'n':
        return '\n';
      case 'p':
        return dt.hour >= 12 ? 'PM' : 'AM';
      case 'P':
        return dt.hour >= 12 ? 'pm' : 'am';
      case 'R':
        return '%02d:%02d'.sprintf(dt.hour, dt.minute);
      case 'r':
        return '%02d:%02d:%02d %s'.sprintf(((dt.hour + 11) % 12) + 1, dt.minute.dt.second, dt.hour >= 12 ? 'PM' : 'AM');
      case 's':
        return '%d'.sprintf(dt.julianDay * 86400);
      case 'S':
        return '%02d'.sprintf(dt.second);
      case 'T':
        return '%02d:%02d:%02d'.sprintf(dt.hour, dt.minute.dt.second);
      case 'u':
        return '%d'.sprintf(dt.day + 1);
      case 'U':
        return '%02d'.sprintf(dt.weekOfYear());
      case 'w':
        return '%d'.sprintf(dt.day);
      case 'y':
        return '%02d'.sprintf(dt.year % 100);
      case 'Y':
        return '%04d'.sprintf(dt.year);
      case 'z':
        return RZLib._tzString(dt);
      case '/':
        return '%06d'.sprintf(dt.uSecond).replace(/0+$/, '');
      default:
        return $1;
    }
  });
  return str;
};

RZLib.duration = function (t) {
  if (t == null) return '';

  if (t < 60) return '%.1fsec'.sprintf(t);

  t /= 60;
  if (t < 60) return '%.1fmin'.sprintf(t);

  t = 60;
  if (t < 60) return '%.1fhr'.sprintf(t);

  t /= 24;
  return '%.1dy'.sprintf(t);
};

//
//  RZLib.::Date:
//
RZLib.Date = RZLib.subclass(RZLib.Object, 'RZLib.Date', {
  'RZLib.Date': function () {
    RZLib.Date.superConstructor.call();
    this._julianDay_;
    this._year_;
    this._month_;
    this._day_;
    this._hasJulian_;
    this._hasParts_;
  },

  isUndef: function () {
    return !this._hasJulian_ && !this._hasParts_;
  },
  isValid: function () {
    if (!this._hasJulian_ && !this._hasParts_) return false;

    if (this._hasParts_) return RZLib.Date.isValidYMD(this._year_, this._month_, this._day_);

    return true;
  },
  setYMD: function (yr, mo, dy) {
    this._year_ = parseInt(yr);
    this._month_ = parseInt(mo);
    this._day_ = parseInt(dy);

    if (this._year_ > 0 || this._month_ > 0 || this._day_ > 0) {
      this._hasParts_ = true;
      this._hasJulian_ = false;
      return this;
    }
    this._hasParts_ = false;
    this._hasJulian_ = false;
    return this;
  },
  setToday: function () {
    var d = new Date();
    this.setYMD(d.getFullYear(), d.getMonth() + 1, d.getDate());
    return this;
  },

  daysBetween: function (other) {
    return other.julianDay - this.julianDay;
  },
  dayOfWeek: function () {
    return (this.julianDay + 4) % 7;
  },
  dayOfYear: function () {
    var newYearsDay = (RZLib.Date.newYearsDays[this.year] =
      RZLib.Date.newYearsDays[this.year] || RZLib.Date.newForDate(this.year, 1, 1));
    return this.julianDay - newYearsDay.julianDay + 1;
  },
  weekOfYear: function () {
    var newYearsDay = RZLib.Date.newForYMD(this._year_, 1, 1);
    return Math.floor((this.julianDay - newYearsDay.julianDay + (newYearsDay.dayOfWeek() % 7)) / 7) + 1;
  },

  localtime: function () {
    this.makeParts();
    return 0, 0, 0, this._day_, this._month_ - 1, this._year_ - 1900, this.dayOfWeek;
  },
  addYMD: function (yr, mo, dy) {
    if (dy) {
      this.makeJulian();
      this._julianDay_ += dy;
      this._hasParts_ = false;
    }

    if (mo || yr) {
      this.makeParts();
      this._month_ += mo;
      this._year_ += yr;
      this._hasJulian_ = false;
      this.normalize();
    }

    return this;
  },
  normalize: function () {
    if (this._month_ < 1) {
      var m1 = -this._month_;
      var m0 = m1 + 1;
      this._month_ = ((12 - m0) % 12) + 1;
      this._year_ -= ~~(m1 / 12) + 1;
    } else {
      this._year_ += Math.floor((this._month_ - 1) / 12);
      this._month_ = ((this._month_ - 1) % 12) + 1;
    }
    this._hasJulian_ = false;
    return this;
  },

  strftime: function (fmt) {
    return RZLib.strftime(fmt || RZLib.Date.defaultFormat, this);
  },
  stringValue: function (fmt) {
    if (this.makeParts() == null) return null;

    if (!fmt) fmt = RZLib.Date.defaultFormat;

    return RZLib.strftime(fmt, this);
  },
  toString: function (fmt) {
    if (this.makeParts() == null) return null;

    if (!fmt) fmt = RZLib.Date.defaultFormat;

    return RZLib.strftime(fmt, this);
  },
  valueOf: function () {
    if (this.makeJulian()) return this._julianDay_;
    return NaN;
  },
  setStringValue: function (str) {
    var m;
    if (str && (m = RZLib.parseDate(str))) {
      this.setYMD(m[1], m[2], m[3]);
    } else {
      this._hasJulian_ = false;
      this._hasParts_ = false;
    }
    return this;
  },
  makeJulian: function () {
    if (this._hasJulian_) return this;
    if (!this._hasParts_) {
      this._julianDay_ = 0;
      return null;
    }

    this._julianDay_ = RZLib.Date.gtoj(this._year_, this._month_, this._day_);
    this._hasJulian_ = true;

    return this;
  },
  makeParts: function () {
    if (this._hasParts_) return this;
    if (!this._hasJulian_) {
      this._year_ = this._month_ = this._day_ = 0;
      return null;
    }

    var ymd = RZLib.Date.jtog(this._julianDay_);
    this._year_ = ymd[0];
    this._month_ = ymd[1];
    this._day_ = ymd[2];
    this._hasParts_ = true;

    return this;
  },
});

RZLib.Date.newYearsDays = {};

RZLib.Date.prototype.__defineGetter__('year', function (y) {
  this.makeParts();
  return this._year_;
});
RZLib.Date.prototype.__defineSetter__('year', function (y) {
  this.makeParts();
  this._year_ = y;
  this._hasJulian_ = false;
  return this;
});

RZLib.Date.prototype.__defineGetter__('month', function (y) {
  this.makeParts();
  return this._month_;
});
RZLib.Date.prototype.__defineSetter__('month', function (y) {
  this.makeParts();
  this._month_ = y;
  this._hasJulian_ = false;
  return this;
});

RZLib.Date.prototype.__defineGetter__('day', function (y) {
  this.makeParts();
  return this._day_;
});
RZLib.Date.prototype.__defineSetter__('day', function (y) {
  this.makeParts();
  this._day_ = y;
  this._hasJulian_ = false;
  return this;
});

RZLib.Date.prototype.__defineGetter__('julianDay', function () {
  this.makeJulian();
  return this._julianDay_;
});
RZLib.Date.prototype.__defineSetter__('julianDay', function (jd) {
  this._julianDay_ = ~~jd;
  this._hasJulian_ = true;
  this._hasParts_ = false;
  return this;
});

RZLib.Date.prototype.__defineGetter__('excelDay', function () {
  this.makeJulian();
  return this._julianDay_ + 25569;
});
RZLib.Date.prototype.__defineSetter__('excelDay', function (ed) {
  this._julianDay_ = ~~ed - 25569;
  this._hasJulian_ = true;
  this._hasParts_ = false;
  return this;
});

RZLib.Date.defaultFormat = '%Y-%m-%d';

RZLib.Date.newWithToday = function () {
  var nd = new RZLib.Date();
  return nd.setToday();
};

RZLib.Date.newForYMD = RZLib.Date.newForDate = function (y, m, d) {
  var nd = new RZLib.Date();
  return nd.setYMD(y, m, d);
};

RZLib.Date.newForJulianDay = function (jd) {
  var nd = new RZLib.Date();
  nd.julianDay = jd;
  return nd;
};

RZLib.Date.newForExcelDay = function (ed) {
  var nd = new RZLib.Date();
  nd.julianDay = ed;
  return nd;
};

RZLib.Date.newForStringValue = function (s) {
  var nd = new RZLib.Date();
  return nd.setStringValue(s);
};

RZLib.Date.isLeapYear = function (y) {
  return RZLib.Date.jtog(RZLib.Date.gtoj(y, 2, 29))[2] == 29;
};

RZLib.Date.daysInMonth = function (y, m) {
  return [-1, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][m] + (m == 2 && RZLib.Date.isLeapYear(y) ? 1 : 0);
};

RZLib.Date.jdow = function (jDay) {
  return (jDay + 4) % 7;
};

RZLib.Date.nthDayOfNthWeek = function (yr, mo, dayOfWeek, weekOfMonth) {
  var dtFirst = RZLib.Date.newForYMD(yr, mo, 1);
  var dyFirst = dtFirst.julianDay;

  var dyRet = dyFirst + (6 - RZLib.Date.jdow(dyFirst - (dayOfWeek + 1)));
  var dtRet = RZLib.Date.newForJulianDay(dyRet + (weekOfMonth - 1) * 7);

  if (dtRet.month != dtFirst.month) {
    dtRet.addInterval(0, 0, -7);
  }

  return dtRet;
};

RZLib.Date.isValidYMD = function (year, month, day, extra) {
  if ((extra || '').trim().length)
    // trailing text returned from parseDate() is invalid
    return false;

  if (year < 1900 || year > 2100) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > RZLib.Date.daysInMonth(year, month)) return false;

  return true;
};

RZLib.Date.gtoj = function (year, month, day) {
  if (month > 2) {
    month -= 3;
  } else {
    month += 9;
    year -= 1;
  }

  var century = ~~(year / 100);
  var ya = year - 100 * century;

  var julianDate = ~~((146097 * century) / 4) + ~~((1461 * ya) / 4) + ~~((153 * month + 2) / 5) + day;

  julianDate -= 719469; // shift epoc from 0000/02/28 to 1970/01/01.

  return julianDate;
};

RZLib.Date.jtog = function (julianDate) {
  julianDate += 719469; // shift epoc from 1970/01/01 to 0000/02/28 for calcs.

  var year = ~~((4 * julianDate - 1) / 146097);
  julianDate = 4 * julianDate - 146097 * year - 1;
  var day = ~~(julianDate / 4);

  julianDate = ~~((4 * day + 3) / 1461);
  day = 4 * day + 3 - 1461 * julianDate;
  day = ~~((day + 4) / 4);

  var month = ~~((5 * day - 3) / 153);
  day = 5 * day - 3 - 153 * month;
  day = ~~((day + 5) / 5);

  year = 100 * year + julianDate;
  if (month < 10) {
    month += 3;
  } else {
    month -= 9;
    year += 1;
  }

  return [year, month, day];
};

//
//  RZLib.::Time:
//
RZLib.Time = RZLib.subclass(RZLib.Object, 'RZLib.Time', {
  'RZLib.Time': function () {
    RZLib.Time.superConstructor.call();
    this._julianTime_;
    this._hour_;
    this._minute_;
    this._second_;
    this._hasJulian_;
    this._hasParts_;
  },

  isUndef: function () {
    return this._hasJulian_ || this._hasParts_;
  },
  isValid: function () {
    if (!this._hasJulian_ && !this._hasParts_) return false;

    if (this._hasParts_) return RZLib.Time.isValidHMS(this._hour_, this._minute_, this._second_);

    return true;
  },
  setHMS: function (hr, mn, sc) {
    this._hour_ = parseInt(hr);
    this._minute_ = parseInt(mn);
    this._second_ = parseInt(sc);

    if (this._hour_ >= 0 && this._minute_ >= 0 && this._second_ >= 0) {
      this._hasParts_ = true;
      this._hasJulian_ = false;
      return this;
    }
    this._hasParts_ = false;
    this._hasJulian_ = false;
    return this;
  },
  setNow: function () {
    var d = new Date();
    this.setHMS(d.getHours(), d.getMinutes(), d.getSeconds());
    return this;
  },

  timeBetween: function (other) {
    return other.julianTime() - this.julianTime();
  },

  addTime: function (t) {
    return this.addHMS(t.hour, t.minute, t.second);
  },

  addHMS: function (hr, mn, sc) {
    this.makeJulian();
    this._julianTime_ += hr * 3600 + mn * 60 + sc;
    this._julianTime_ = (this._julianTime_ + 864000) % 86400;
    this._hasParts_ = false;
    return this;
  },

  subTime: function (t) {
    return this.subHMS(t.hour, t.minute, t.second);
  },

  subHMS: function (hr, mn, sc) {
    this.makeJulian();
    this._julianTime_ -= hr * 3600 + mn * 60 + sc;
    this._julianTime_ = (this._julianTime_ + 864000) % 86400;
    this._hasParts_ = false;
    return this;
  },

  setStringValue: function (str) {
    var m;
    if (str && (m = RZLib.parseTime(str))) {
      var ampm = m[4].toUpperCase();
      var hour = parseInt(m[1]);
      var minute = parseInt(m[2]);
      var second = parseInt(m[3]);

      if (ampm == 'AM' && hour == 12) {
        hour = 0;
      } else if (ampm == 'PM' && hour < 12) {
        hour += 12;
      }
      this.setHMS(hour, minute, second);
    } else {
      this._hasJulian_ = false;
      this._hasParts_ = false;
    }
    return this;
  },

  strftime: function (fmt) {
    return RZLib.strftime(fmt || RZLib.Time.defaultFormat, this);
  },
  stringValue: function () {
    return RZLib.strftime(RZLib.Time.defaultFormat, this);
  },
  toString: function () {
    return RZLib.strftime(RZLib.Time.defaultFormat, this);
  },
  valueOf: function () {
    if (this.makeJulian()) return this._julianTime_;
    return NaN;
  },

  makeJulian: function () {
    if (this._hasJulian_) return this;
    if (!this._hasParts_) {
      this._julianTime_ = 0;
      return null;
    }

    this._julianTime_ = this._hour_ * 3600 + this._minute_ * 60 + this._second_;
    this._hasJulian_ = true;

    return this;
  },
  makeParts: function () {
    if (this._hasParts_) return this;
    if (!this._hasJulian_) {
      this._hour_ = this._minute_ = this._second_ = 0;
      return null;
    }

    var t = this._julianTime_;

    this._hour_ = ~~(t / 3600);
    t %= 3600;

    this._minute_ = ~~(t / 60);
    t %= 60;

    this._second_ = t;

    this._hasParts_ = 1;

    return this;
  },
});

RZLib.Time.prototype.__defineGetter__('hour', function () {
  this.makeParts();
  return this._hour_;
});
RZLib.Time.prototype.__defineSetter__('hour', function (h) {
  this.makeParts();
  this._hour_ = h;
  this._hasJulian_ = false;
  return this;
});

RZLib.Time.prototype.__defineGetter__('minute', function () {
  this.makeParts();
  return this._minute_;
});
RZLib.Time.prototype.__defineSetter__('minute', function (m) {
  this.makeParts();
  this._minute_ = m;
  this._hasJulian_ = false;
  return this;
});

RZLib.Time.prototype.__defineGetter__('second', function () {
  this.makeParts();
  return this._second_;
});
RZLib.Time.prototype.__defineSetter__('second', function (s) {
  this.makeParts();
  this._second_ = s;
  this._hasJulian_ = false;
  return this;
});

RZLib.Time.prototype.__defineGetter__('julianTime', function () {
  this.makeJulian();
  return this._julianTime_;
});
RZLib.Time.prototype.__defineSetter__('julianTime', function (j) {
  this.makeJulian();
  this._julianTime_ = j;
  this._hasParts_ = false;
  return this;
});

RZLib.Time.defaultFormat = '%H:%M:%S';

RZLib.Time.newWithNow = function () {
  var t = new RZLib.Time();
  return t.setNow();
};

RZLib.Time.newForHMS = function (h, m, s) {
  var nd = new RZLib.Time();
  return nd.setHMS(h, m, s);
};
RZLib.Time.newForStringValue = function (s) {
  var t = new RZLib.Time();
  return t.setStringValue(s);
};

RZLib.Time.isValidHMS = function (hour, minute, second, ampm, extra) {
  hour = parseInt(hour);
  minute = parseInt(minute);
  second = parseInt(second);
  if ((extra || '').trim().length)
    // trailing text returned from parseTime() is invalid
    return false;

  if (ampm && ampm.match(/^(am|pm)$/i)) {
    if (hour < 1 || hour > 12) return false;
  } else {
    if (hour < 0 || hour > 23) return false;
  }

  if (minute < 0 || minute > 59) return false;
  if (second < 0 || second > 59) return false;

  return true;
};

RZLib.Time.gtoj = function (hr, mn, sc) {
  return hr * 3600 + mn + 60 + sc;
};

RZLib.Time.jtog = function (t) {
  var hr = ~~(t / 3600);
  t %= 3600;

  var mn = ~~(t / 60);
  t %= 60;

  return [hr, mn, t];
};

//
//  RZLib.Timestamp:
//
RZLib.Timestamp = RZLib.subclass(RZLib.Object, 'RZLib.Timestamp', {
  'RZLib.Timestamp': function () {
    RZLib.Timestamp.superConstructor.call();
    this._julianTime_;
    this._year_;
    this._month_;
    this._day_;
    this._hour_;
    this._minute_;
    this._second_;
    this._uSecond_;
    this._tzOffset_;
    this._hasJulian_;
    this._hasParts_;
  },

  isValid: function () {
    return this._hasJulian_ || this._hasParts_;
  },
  setNow: function () {
    var d = new Date();
    this.setDateTime(
      d.getFullYear(),
      d.getMonth() + 1,
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds(),
      d.getMilliseconds() * 1000
    );
    this._tzOffset_ = d.getTimezoneOffset() * -60000000;
    return this;
  },
  setDateTime: function (yr, mo, dy, hr, mn, sc, us, tz) {
    this._year_ = parseInt(yr);
    this._month_ = parseInt(mo);
    this._day_ = parseInt(dy);
    this._hour_ = parseInt(hr);
    this._minute_ = parseInt(mn);
    this._second_ = parseInt(sc);
    this._uSecond_ = us != undefined ? parseInt(us) : 0;
    this._tzOffset_ =
      tz != undefined
        ? RZLib.Timestamp.normalizeTzOffset(tz)
        : new Date(
            this._year_,
            this._month_,
            this._day_,
            this._hour_,
            this._minute_,
            this._second_
          ).getTimezoneOffset() * -60000000;

    if (
      this._year_ > 0 ||
      this._month_ > 0 ||
      this._day_ > 0 ||
      this._hour_ >= 0 ||
      this._minute_ >= 0 ||
      this._second_ >= 0
    ) {
      this._hasParts_ = true;
      this._hasJulian_ = false;
      return this;
    }
    this._hasParts_ = false;
    this._hasJulian_ = false;
    return this;
  },
  setDate: function (yr, mo, dy) {
    this.setDateTime(yr, mo, dy, 0, 0, 0, 0);
    return this;
  },

  timeBetween: function (other) {
    return ~~((other.julianTime - this.julianTime) / RZLib.Timestamp.USECS_PER_SECOND);
  },
  daysBetween: function (other) {
    return ~~((other.julianTime - this.julianTime) / RZLib.Timestamp.USECS_PER_DAY);
  },
  dayOfWeek: function () {
    return (~~((this.julianTime + this._tzOffset_) / RZLib.Timestamp.USECS_PER_DAY) + 4) % 7;
  },
  dayOfYear: function () {
    var newYearsDay = (RZLib.Timestamp.newYearsDays[this.year] =
      RZLib.Timestamp.newYearsDays[this.year] || RZLib.Timestamp.newForDate(this.year, 1, 1));
    return ~~((this.julianTime - newYearsDay.julianTime) / USECS_PER_DAY) + 1;
  },
  weekOfYear: function () {
    var newYearsDay = RZLib.Timestamp.newForDate(this._year_, 1, 1);
    return (
      Math.floor(
        (~~((this.julianTime - newYearsDay.julianTime) / RZLib.Timestamp.USECS_PER_DAY) +
          (newYearsDay.dayOfWeek() % 7)) /
          7
      ) + 1
    );
  },

  localtime: function () {
    this.makeParts();
    return [
      this._second_,
      this._minute_,
      this._hour_,
      this._day_,
      this._month_ - 1,
      this._year_ - 1900,
      this.dayOfWeek(),
      this.dayOfYear(),
      0,
      ~~(this._tzOffset_ / RZLib.Timestamp.USECS_PER_SECOND),
    ];
  },
  addInterval: function (yr, mo, dy, hr, mn, sc, us) {
    if (dy || hr || mn || sc || us) {
      this.makeJulian();
      if (dy != undefined) this._julianTime_ += dy * RZLib.Timestamp.USECS_PER_DAY;

      if (hr != undefined) this._julianTime_ += hr * RZLib.Timestamp.USECS_PER_HOUR;

      if (mn != undefined) this._julianTime_ += mn * RZLib.Timestamp.USECS_PER_MINUTE;

      if (sc != undefined) this._julianTime_ += sc * RZLib.Timestamp.USECS_PER_SECOND;

      if (us != undefined) this._julianTime_ += uc;

      this._hasParts_ = false;
    }

    if (mo || yr) {
      this.makeParts();
      this._month_ += mo;
      this._year_ += yr;
      this._hasJulian_ = false;
      this.normalize();
    }

    return this;
  },

  normalize: function () {
    if (this._month_ < 1) {
      var m1 = -this._month_;
      var m0 = m1 + 1;
      this._month_ = ((12 - m0) % 12) + 1;
      this._year_ -= ~~(m1 / 12) + 1;
    } else {
      this._year_ += Math.floor((this._month_ - 1) / 12);
      this._month_ = ((this._month_ - 1) % 12) + 1;
    }
    this._hasJulian_ = false;
    return this;
  },

  strftime: function (fmt) {
    if (this.makeParts() == null) return null;

    if (!fmt) fmt = RZLib.Timestamp.defaultFormat;

    return RZLib.strftime(fmt, this);
  },
  stringValue: function (fmt) {
    if (this.makeParts() == null) return null;

    if (!fmt) fmt = RZLib.Timestamp.defaultFormat;

    return RZLib.strftime(fmt, this);
  },
  toString: function (fmt) {
    if (this.makeParts() == null) return null;

    if (!fmt) fmt = RZLib.Timestamp.defaultFormat;

    return RZLib.strftime(fmt, this);
  },
  valueOf: function () {
    if (this.makeJulian()) return this._julianTime_;
    return NaN;
  },
  setStringValue: function (str) {
    var m;
    if (str && (m = RZLib.parseTimestamp(str))) {
      var tzOff = 0;
      if (m[8] != undefined) {
        var hhmm = m[8].match(/^\+?(-?\d\d)(\d\d)?$/);
        tzOff = hhmm[1] * RZLib.Timestamp.USECS_PER_HOUR + (hhmm[2] || 0) * RZLib.Timestamp.USECS_PER_MINUTE;
      }
      this.setDateTime(m[1], m[2], m[3], m[4], m[5], m[6], m[7], tzOff);
    } else {
      this._hasJulian_ = false;
      this._hasParts_ = false;
    }
    return this;
  },
  setTzOffset: function (tzOff) {
    this.makeJulian();
    this._tzOffset_ = RZLib.Timestamp.normalizeTzOffset(tzOff);
    this._hasParts_ = false;
    return this;
  },
  makeJulian: function () {
    if (this._hasJulian_) return this;
    if (!this._hasParts_) {
      this._julianTime_ = 0;
      return null;
    }

    this._julianTime_ =
      RZLib.Date.gtoj(this._year_, this._month_, this._day_) * RZLib.Timestamp.USECS_PER_DAY +
      this._hour_ * RZLib.Timestamp.USECS_PER_HOUR +
      this._minute_ * RZLib.Timestamp.USECS_PER_MINUTE +
      this._second_ * RZLib.Timestamp.USECS_PER_SECOND +
      this._uSecond_ -
      this._tzOffset_;
    this._hasJulian_ = true;

    return this;
  },
  makeParts: function () {
    if (this._hasParts_) return this;
    if (!this._hasJulian_) {
      this._year_ = this._month_ = this._day_ = this._hour_ = this._minute_ = this._second_ = this._uSecond_ = 0;
      return null;
    }

    var t = this._julianTime_ + this._tzOffset_;

    this._uSecond_ = t % 1000000;
    t = ~~(t / 1000000);

    this._second_ = t % 60; // sec/minutes
    t = ~~(t / 60); // convert to secs to minutes

    this._minute_ = t % 60; // minutes/hour
    t = ~~(t / 60); // convert minutes to hours

    this._hour_ = t % 24; // hours/day
    t = ~~(t / 24); // convert hours to days

    var ymd = RZLib.Date.jtog(t);
    this._year_ = ymd[0];
    this._month_ = ymd[1];
    this._day_ = ymd[2];
    this._hasParts_ = true;

    return this;
  },
});

RZLib.Timestamp.USECS_PER_DAY = 86400000000;
RZLib.Timestamp.USECS_PER_HOUR = 3600000000;
RZLib.Timestamp.USECS_PER_MINUTE = 60000000;
RZLib.Timestamp.USECS_PER_SECOND = 1000000;

RZLib.Timestamp.newYearsDays = {};

RZLib.Timestamp.prototype.__defineGetter__('year', function () {
  this.makeParts();
  return this._year_;
});
RZLib.Timestamp.prototype.__defineSetter__('year', function (y) {
  this.makeParts();
  this._year_ = y;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('month', function () {
  this.makeParts();
  return this._month_;
});
RZLib.Timestamp.prototype.__defineSetter__('month', function (m) {
  this.makeParts();
  this._month_ = m;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('day', function () {
  this.makeParts();
  return this._day_;
});
RZLib.Timestamp.prototype.__defineSetter__('day', function (d) {
  this.makeParts();
  this._day_ = d;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('hour', function () {
  this.makeParts();
  return this._hour_;
});
RZLib.Timestamp.prototype.__defineSetter__('hour', function (h) {
  this.makeParts();
  this._hour_ = h;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('minute', function () {
  this.makeParts();
  return this._minute_;
});
RZLib.Timestamp.prototype.__defineSetter__('minute', function (m) {
  this.makeParts();
  this._minute_ = m;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('second', function () {
  this.makeParts();
  return this._second_;
});
RZLib.Timestamp.prototype.__defineSetter__('second', function (s) {
  this.makeParts();
  this._second_ = s;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('uSecond', function () {
  this.makeParts();
  return this._uSecond_;
});
RZLib.Timestamp.prototype.__defineSetter__('uSecond', function (u) {
  this.makeParts();
  this._uSecond_ = u;
  this._hasJulian_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('tzOffset', function () {
  return this._tzOffset_;
});
RZLib.Timestamp.prototype.__defineSetter__('tzOffset', function () {
  this.setTzOffset(tzOff);
});

RZLib.Timestamp.prototype.__defineGetter__('julianTime', function () {
  this.makeJulian();
  return this._julianTime_;
});
RZLib.Timestamp.prototype.__defineSetter__('julianTime', function (t) {
  this._julianTime_ = t;
  this._hasJulian_ = true;
  this._hasParts_ = false;
  return this;
});

RZLib.Timestamp.prototype.__defineGetter__('excelDay', function () {
  this.makeJulian();
  return this._julianTime_ / RZLib.Timestamp.USECS_PER_DAY + 25569;
});
RZLib.Timestamp.prototype.__defineSetter__('excelDay', function (ed) {
  this._julianTime_ = (ed - 25569) * RZLib.Timestamp.USECS_PER_DAY;
  this._hasJulian_ = true;
  this._hasParts_ = false;
  return this;
});

RZLib.Timestamp.defaultFormat = '%Y/%m/%d %H:%M:%S.%/%z';

RZLib.Timestamp.newWithNow = function () {
  var nd = new RZLib.Timestamp();
  return nd.setNow();
};

RZLib.Timestamp.newForDateTime = function (yr, mo, dy, hr, mn, sc, us, tz) {
  var nd = new RZLib.Timestamp();
  return nd.setDateTime(yr, mo, dy, hr, mn, sc, us, tz);
};

RZLib.Timestamp.newForDate = function (yr, mo, dy) {
  var nd = new RZLib.Timestamp();
  return nd.setDate(yr, mo, dy);
};

RZLib.Timestamp.newForJulianTime = function (jt) {
  var nd = new RZLib.Timestamp();
  nd.julianTime = jt;
  return nd;
};

RZLib.Timestamp.newForJulianDay = function (jd) {
  var nd = new RZLib.Timestamp();
  nd.julianDay = jd;
  return nd;
};

RZLib.Timestamp.newForExcelDay = function (ed) {
  var nd = new RZLib.Timestamp();
  nd.excelDay = ed;
  return nd;
};

RZLib.Timestamp.newForStringValue = function (s) {
  var nd = new RZLib.Timestamp();
  return nd.setStringValue(s);
};

RZLib.Timestamp.normalizeTzOffset = function (tzOff) {
  if (tzOff <= 12 && tzOff >= -12) {
    // between -12 and +12? tzOff was in hours
    tzOff = tzOff * RZLib.Timestamp.USECS_PER_HOUR;
  } else if (tzOff <= 12 * 60 && tzOff >= -12 * 60) {
    // between -720 and +720? tzOff was in minutes
    tzOff = ~~(tzOff * RZLib.Timestamp.USECS_PER_MINUTE);
  } else if (tzOff <= 12 * 3600 && tzOff >= -12 * 3600) {
    // between -43200 and +43200? tzOff was in seconds
    tzOff = ~~(tzOff * RZLib.Timestamp.USECS_PER_SECOND);
  } // else assume uSecs

  if (tzOff == undefined) tzOff = 0;

  return tzOff;
};

export default RZLib;
